import axios from "axios";
import { FETCH_TEXTURES, FETCH_USER, DO_NOTHING, FETCH_TAGS } from "./types";

export const fetchUser = () => async dispatch => {
  const res = await axios.get("/api/current_user");

  dispatch({ type: FETCH_USER, payload: res.data });
};

export const fetchTextures = filters => async dispatch => {
  const res = await axios.get("/api/fetch_textures", { params: filters });
  dispatch({ type: FETCH_TEXTURES, payload: res.data });
};

export const fetchLatestTextures = () => async dispatch => {
  const res = await axios.get("/api/fetch_latest_textures");
  dispatch({ type: FETCH_TEXTURES, payload: res.data });
};

export const createSet = values => async dispatch => {
  const res = await axios.post("/api/create_set", values);
  dispatch({ type: DO_NOTHING, payload: res.data });
};

export const fetchCategoryTags = category_ids => async dispatch => {
  const res = await axios.get("/api/fetch_category_tags", {
    params: { category_ids }
  });
  dispatch({ type: FETCH_TAGS, payload: res.data });
};



// WEBPACK FOOTER //
// ./src/actions/index.js